/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Templates_HintInputs */



/**
* | output |
* | --- |
* | "Fill both messages from a preset, then edit before saving." |
*
* @param {Partner_Status_Templates_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_templates_hint = /** @type {((inputs?: Partner_Status_Templates_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Templates_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beide Nachrichten aus einer Vorlage befüllen und vor dem Speichern anpassen.")
	return /** @type {LocalizedString} */ ("Fill both messages from a preset, then edit before saving.")
});